'use client';

import React, { type ReactNode } from 'react';
import styled from 'styled-components';
import { useInView } from 'react-intersection-observer';
import { useStickyNav } from './StickyNavContext';

const Wrapper = styled.div<{ $isSticky: boolean; $top: number; $animate: boolean }>`
  position: ${({ $isSticky }) => ($isSticky ? 'sticky' : 'static')};
  top: ${({ $top }) => $top}px;
  z-index: 10;
  box-shadow: ${({ $isSticky }) => ($isSticky ? ({ theme }) => theme?.kallisto?.shadow?.mediumDownShadow : 'none')};
  transition: ${({ $animate }) => ($animate ? 'top 0.35s ease-out' : 'none')};
`;

const StickyNavFilters = ({ children, topOffset }: { children: ReactNode; topOffset: number }) => {
  const { isOut, scrollDirection, setIsOut } = useStickyNav();
  const { ref: sentinelRef } = useInView({ threshold: 0, onChange: (inView) => setIsOut(!inView) });

  return (
    <>
      <div ref={sentinelRef} style={{ height: 0, width: 0 }} />
      <Wrapper
        $isSticky={isOut || scrollDirection === 'up'}
        $top={isOut && scrollDirection === 'up' ? topOffset : 0}
        $animate={isOut}
      >
        {children}
      </Wrapper>
    </>
  );
};

export default StickyNavFilters;
